/*
 * @Description: 
 * @Author: shenkaiyao
 * @Date: 2020-09-24 15:36:00
 * @LastEditors: 
 * @LastEditTime: 2020-09-24 15:39:58
 */
import DrawerTabs from './drawerTabs';

export default DrawerTabs